<template>
  <ul class="cheapest-deliveries-list" :class="{ _mobile: isMobile }">
    <li
      v-for="(item, index) in cheapestDeliveries"
      :key="`cheapest-deliveries-${index}`"
      class="cheapest-deliveries-list__item"
    >
      <template v-if="isMobile">
        <span>{{ item.name }}</span>
        <span>{{ item.price }}</span>
      </template>
      <template v-else>
        {{ item.name }} - {{ item.price }}
      </template>
    </li>
  </ul>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import { checkMobile } from '@/utils/deviceCheck';

export default defineComponent({
  name: 'CheapestDeliveries',
  props: {
    cheapestDeliveries: { type: Array, default: () => ([]) },
  },
  setup() {
    const isMobile = checkMobile();

    return { isMobile };
  },
});
</script>

<style lang="less">
.cheapest-deliveries-list {
  .list-reset();

  padding: @size-x3 @size-x4;

  &__item {
    .small();

    margin: 0;

    &:not(:first-child) {
      margin-top: @main-size;
    }
  }

  &._mobile &__item {
    .p();

    display: flex;
    justify-content: space-between;

    &:not(:first-child) {
      margin-top: @size-x2;
    }
  }
}
</style>
